module.exports = __webpack_public_path__ + "static/Solution_Ad3-a996215590e0f22d461664d2aca527e8.png";